{
  "passengersSelect": {
    "passengers": {
      "amount": "0 passengers | {n} passenger | {n} passengers | {n} passengers",
      "adults": "Adults",
      "adultShort": "{n} adt",
      "children": "Children",
      "childShort": "{n} chd",
      "infants": "Infants",
      "infantShort": "{n} inf"
    },
    "cabinClass": {
      "economy": "economy",
      "business": "business class",
      "youth": "youth fare"
    }
  }
}
